// The user's label set, per account, in localStorage. A label is applied to mail
// as a JMAP keyword ($km-label-<name>); this module just remembers which labels
// EXIST (seeding a few) so the sidebar and the per-message label menu can list
// them even before any mail carries them. Colors are derived from the name so
// custom labels get a stable color too.
const KEY = (email) => `km-labels:${(email || '').toLowerCase()}`;
const DEFAULTS = ['Work', 'Legal', 'Ops'];

export function listLabels(email) {
  try { const v = JSON.parse(localStorage.getItem(KEY(email))); if (Array.isArray(v)) return v; } catch { /* ignore */ }
  return DEFAULTS.slice();
}
export function saveLabels(email, labels) {
  const uniq = [...new Map(labels.map((l) => l.trim()).filter(Boolean).map((l) => [l.toLowerCase(), l])).values()];
  localStorage.setItem(KEY(email), JSON.stringify(uniq));
  return uniq;
}
export function addLabel(email, name) { return saveLabels(email, [...listLabels(email), name]); }
export function removeLabel(email, name) { return saveLabels(email, listLabels(email).filter((l) => l.toLowerCase() !== name.toLowerCase())); }

// The JMAP keyword that marks a message as carrying label `name`.
export const labelKeyword = (name) => `$km-label-${(name || '').toLowerCase()}`;

const PALETTE = ['#1397ab', '#8b5cf6', '#f59e0b', '#ef4444', '#10b981', '#6366f1', '#ec4899', '#14b8a6', '#f97316', '#0ea5e9'];
export function labelColor(name) {
  let h = 0; const s = (name || '').toLowerCase();
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
